import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { IPilot } from 'src/models/pilot.model';
import services from 'src/services/pilot.service';
import { formatPilotData } from 'src/selectors/pilot.selector';

export const actionTypes = {
  PILOT_FETCH: 'PILOT_FETCH',
  PILOT_ADD: 'PILOT_ADD',
  PILOT_UPDATE: 'PILOT_UPDATE',
  PILOT_DELETE: 'PILOT_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.PILOT_FETCH,
    service: services.listGET,
  },
  addPOST: {
    type: actionTypes.PILOT_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.PILOT_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.PILOT_DELETE,
    service: services.itemDELETE,
  },
};

export type IPilotAsync = typeof asyncActions;

export interface IPilotState extends ICommonState<IPilotAsync> {
  data?: IPilot;
  list: IPilot[];
  total: number;
}

export const defaultState: IPilotState = {
  status: {},
  list: [],
  total: 0,
};

const PilotReducer = (
  state: IPilotState = defaultState,
  action: IReducerAction<IPilotAsync>
): IPilotState => {
  switch (action.type) {
    case actionTypes.PILOT_FETCH: {
      return {
        ...state,
        list: (action.payload?.pilot.rows ?? []).map(formatPilotData),
        total: action.payload?.pilot.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default PilotReducer;
